import * as Yup from "yup";

const MIN_TITLE_LENGTH: number = 3;
export const MAX_TITLE_LENGTH: number = 50;

const MIN_DESCRIPTION_LENGTH: number = 3;
export const MAX_DESCRIPTION_LENGTH: number = 90;

export const AddCompayPolicyNudgeValidator = Yup.object({
  title: Yup.string()
    .required("Title is Required")
    .min(
      MIN_TITLE_LENGTH, 
      `Title must be at least ${MIN_TITLE_LENGTH} characters long`
    )
    .max(
      MAX_TITLE_LENGTH, 
      `Name must be less than ${MAX_TITLE_LENGTH} characters long`
    ),
  description: Yup.string()
    .required("Description is Required")
    .min(
      MIN_DESCRIPTION_LENGTH, 
      `Description must be at least ${MIN_DESCRIPTION_LENGTH} characters long`
    )
    .max(
      MAX_DESCRIPTION_LENGTH, 
      `Description must be less than ${MAX_DESCRIPTION_LENGTH} characters long`
    ),
});

